export default "__VITE_ASSET__CnHGna62__"